import './libs/instrument'
import './index.css'

import * as Sentry from '@sentry/react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Algo deu errado. Tente novamente mais tarde.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
  ,
)
